export default {
  namespaced: true,
  state: {
    list: [],
    add: false,
    userProfile: false,
    userProfileObj: false,

    editRole: false,
    editRoleObj: {},
    editLocation: false,
    editLocationObj: {},
    delete: false,
    deleteObj: {},
  },
  getters: {
    list: state => state.list,
    add: state => state.add,
    userProfile: state => state.userProfile,
    userProfileObj: state => state.userProfileObj,

    editRole: state => state.editRole,
    editRoleObj: state => state.editRoleObj,

    editLocation: state => state.editLocation,
    editLocationObj: state => state.editLocationObj,

    delete: state => state.delete,
    deleteObj: state => state.deleteObj,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    addMutate(state, data) {
      state.add = data;
    },
    userProfileMutate(state, data) {
      state.userProfile = data;
    },
    userProfileObjMutate(state, data) {
      state.userProfileObj = data;
    },
    editRoleMutate(state, data) {
      state.editRole = data;
    },
    editRoleObjMutate(state, data) {
      state.editRoleObj = data;
    },
    editLocationMutate(state, data) {
      state.editLocation = data;
    },
    editLocationObjbMutate(state, data) {
      state.editLocationObj = data;
    },
    deleteMutate(state, data) {
      state.delete = data;
    },
    deleteObjMutate(state, data) {
      state.deleteObj = data;
    },
  },
  actions: {
    setList(context, data) {
      context.commit('listMutate', data);
    },
    setAdd(context, data) {
      context.commit('addMutate', data);
    },
    setUserProfile(context, data) {
      context.commit('userProfileMutate', data);
    },
    setUserProfileObj(context, data) {
      context.commit('userProfileObjMutate', data);
    },
    setEditRole(context, data) {
      context.commit('editRoleMutate', data);
    },
    setEditRoleObj(context, data) {
      context.commit('editRoleObjMutate', data);
    },

    setEditLocation(context, data) {
      context.commit('editLocationMutate', data);
    },
    setEditLocationObj(context, data) {
      context.commit('editLocationObjMutate', data);
    },

    setDelete(context, data) {
      context.commit('deleteMutate', data);
    },
    setDeleteObj(context, data) {
      context.commit('deleteObjMutate', data);
    },
  },
};
